import { Icon } from '@iconify/react'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import config from '../../config'
import { formatDisplayDate } from '../../utils/formatDate';

const NoticeBoardOne = () => {
    const { auth, isAuthenticated } = useAuth();
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNotices = async () => {
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/notifications`);
                if (response.ok) {
                    const data = await response.json();
                    setNotices(data.notifications || []);
                }
            } catch (error) {
                console.error('Error fetching notices:', error);
            } finally {
                setLoading(false);
            }
        };

        if (isAuthenticated) {
            fetchNotices();
        }
    }, [isAuthenticated, auth]);

    return (
        <div className="col-xxl-4">
            <div className="card h-100">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
                        <h6 className="mb-2 fw-bold text-lg mb-0">Notice board</h6>
                        <Link
                            to="#"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link>
                    </div>

                    {loading ? (
                         <div className="d-flex justify-content-center p-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : notices.length > 0 ? (
                        notices.map((notice) => (
                            <div key={notice.id} className="d-flex align-items-start gap-2 mb-20">
                                <img
                                    src="/assets/images/notice/board-img1.png" 
                                    alt=""
                                    className="flex-shrink-0 w-40-px h-40-px me-12 radius-8 me-12"
                                />
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-1 fw-semibold">{notice.title}</h6>
                                    <p className="text-sm text-secondary-light fw-medium mb-1">
                                        {notice.body}
                                    </p>
                                    <span className="text-sm text-secondary-light fw-normal">
                                        {formatDisplayDate(notice.created_at)}
                                    </span>
                                </div>
                            </div>
                        ))
                    ) : (
                         <p className="text-center text-secondary-light">No new notices.</p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default NoticeBoardOne
